import {provideZonelessChangeDetection} from "@angular/core";
import '@angular/common/locales/global/it';
import {bootstrapApplication} from '@angular/platform-browser';
import {appConfig} from './app/app.config';
import {AppComponent} from './app/app.component';
import dayjs from 'dayjs';
import 'dayjs/locale/it';
import {APP_CONFIG} from './app/app-config.model';
import {resolveBrowserAppConfig} from './app/services/app-config.loader';

dayjs.locale('it');

// La config va risolta prima del bootstrap: le rotte CSR (es. area-riservata) non hanno TransferState
// e gli initializer (Keycloak, MFA, tracking) leggono APP_CONFIG subito.
resolveBrowserAppConfig()
  .then((runtimeConfig) => bootstrapApplication(AppComponent, {
    ...appConfig,
    providers: [
      provideZonelessChangeDetection(),
      ...appConfig.providers,
      {provide: APP_CONFIG, useValue: runtimeConfig},
    ],
  }))
  .catch((err) => console.error(err));
